//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types

export const OBTENER_SUB_PREGUNTAS_POR_PREGUNTA = "obtenerSubPreguntasPorPregunta"

// mutation types
export const SET_SUB_PREGUNTAS = "setSubPreguntas";
export const SET_SUB_PREGUNTA = "setSubPreguntas";

const state = {
    subPreguntas:[],
    subPregunta:[],
    data: [
        {id:1, textoPregunta: 'Primer Nivel', preguntasId: 1, estadosId: 1, estado: 'Activo', indicesId: 1}, 
        {id:2, textoPregunta: 'Segundo Nivel', preguntasId: 1, estadosId: 1, estado: 'Activo', indicesId: 1},
        {id:3, textoPregunta: 'Sindicos', preguntasId: 3, estadosId: 1, estado: 'Activo', indicesId: 1},
        {id:4, textoPregunta: 'Concejales', preguntasId: 3, estadosId: 1, estado: 'Activo', indicesId: 2}],
    
}

const getters = {
    obtenerSubPreguntas(state) {
      return state.preguntas;
    },
}

const actions = {
     /**
     * Obtener Listado de preguntas por pregunta seleccionada (preguntasId Padre)
     * @param {*} context 
     * @param {*} indiceId 
     */
    async [OBTENER_SUB_PREGUNTAS_POR_PREGUNTA](context, preguntaId){
        let endpoint = `api/SubPreguntas/Pregunta/${preguntaId}`
       
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_SUB_PREGUNTAS, data.data);
                   // console.log(data)
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)

                    //context.commit(SET_ERROR, response.data.errors);
                });
        });  
    },


}

const mutations = {
    [SET_SUB_PREGUNTAS](state, data) {
        state.subPreguntas = data;
    },

    [SET_SUB_PREGUNTA](state, data) {
        state.subPregunta = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}